import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorWalletTransactionsReducer } from "../../reducer/doctorWalletTransactions/fetchDoctorWalletTransactionsReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
  isLoading: false,
  error: null,
};

const doctorWalletTransactionsSlice = createSlice({
  name: "doctorWalletTransactions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorWalletTransactionsReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchDoctorWalletTransactionsReducer.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload?.transactions || [];
          state.total = action.payload?.total || 0;
          state.page = action.meta.arg?.page || 1;
          state.limit = action.meta.arg?.limit || 10;

          console.log("✅ Wallet Transactions Loaded:", action.payload);
        },
      )
      .addCase(
        fetchDoctorWalletTransactionsReducer.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error =
            action.payload || i18n.t("toast.failedToLoadWalletTransactionHistory");
        },
      );
  },
});

export default doctorWalletTransactionsSlice.reducer;
